import React from "react";
import styled from "styled-components";

const StyledProjectContainer = styled.section`
    display: flex;
    flex-wrap: wrap;
    gap: 30px;
    padding: 50px 15px;
    justify-content: center;
    background: linear-gradient(90deg, #e0f7fa, #b2ebf2);
    box-sizing: border-box;
`;

const StyledImageContainer = styled.div`
    flex: 1;
    min-width: 280px;
    max-width: 550px;
    position: relative;
    overflow: hidden;
    border-radius: 16px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
`;

const StyledImage = styled.img`
    width: 100%;
    height: auto;
    display: block;
`;

const StyledContentContainer = styled.div`
    flex: 1;
    min-width: 280px;
    max-width: 550px;
    background-color: #e1f5fe;
    border-radius: 16px;
    padding: 25px 25px 35px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
`;

const StyledProjectTitle = styled.h2`
    font-size: 24px;
    color: #00796b;
    margin-bottom: 15px;
    font-weight: bold;
    position: relative;
    z-index: 2;
`;

const StyledProjectDescription = styled.p`
    font-size: 16px;
    color: #004d40;
    line-height: 1.5;
    margin-bottom: 0;
    position: relative;
    z-index: 2;
`;

const Decoration = styled.div`
    content: "";
    position: absolute;
    top: 0;
    left: -15px;
    width: 6px;
    height: 100%;
    background-color: #00796b;
    border-radius: 0 4px 4px 0;
    z-index: 1;
`;

const ProjectInfinityBlock = () => {
  return (
    <StyledProjectContainer>
      <StyledImageContainer>
        <StyledImage src="/infinity.jpg" alt="Troniq.news" />
      </StyledImageContainer>
      <StyledContentContainer>
        <Decoration />
        <StyledProjectTitle>Troniq.news: Intelligente Plattform</StyledProjectTitle>
        <StyledProjectDescription>
          Entdecken Sie Troniq.news, wo Kreativität und Technologie zusammenkommen, um revolutionäre Lösungen voranzutreiben.
          Unser Projekt definiert die Zukunft neu, indem es disruptive Werkzeuge und innovative Strategien anbietet, um Branchen zu transformieren.
          Schließen Sie sich der Troniq.news-Revolution an und werden Sie Teil des Wandels!
        </StyledProjectDescription>
      </StyledContentContainer>
    </StyledProjectContainer>
  );
};

export default ProjectInfinityBlock;